import React from "react";
import SidebarList from "./SidebarList";

const Sidebar = ({ songOptions, playingTitle }) => {
  return (
    <div className="md:w-56 mx-auto md:fixed  w-full overflow-y-auto p-3 md:p-0">
      <div className="shadow md:shadow-none px-1 bg-white">
        <h2 className="md:px-2 px-1 py-2  text-left text-3xl md:text-2xl text-gray-600 font-display">
          Menu
        </h2>
        <hr className="border border-gray-100" />
        <SidebarList songOptions={songOptions} playingTitle={playingTitle} />
      </div>
    </div>
  );
};

export default Sidebar;
